(function (Drupal) {
  Drupal.behaviors.voteHandler = {
    attach: function() {
        document
        .querySelectorAll('.contest-item__vote:not(.disabled)')
        .forEach(el => {
          if (el.processed) {
            return;
          }

          el.processed = true;
          el.addEventListener('click', e => {
            e.preventDefault();


            let path = e.target.getAttribute('href') ?? e
              .target
              .closest('.contest-item__vote')
              .querySelector('a')
              .getAttribute('href');

            if (!path) {
              return;
            }

            fetch(path)
              .then(() => {
                let parent = e.target.closest('.contest-item__vote');
                let count = parent.querySelector('.contest-item__count');

                if (!!parent) {
                  parent.classList.toggle('voted', !parent.classList.contains('voted'));
                  count.innerText = parent.classList.contains('voted') ? Number(count.innerText) + 1 : Number(count.innerText) - 1;
                }
              })
              .catch(e => {
                console.error(e);
              })
          })
        })
    }
  }
}(Drupal))
